// Default icons and colors for file mime type

export default {
  pdf: {
    icon: 'mdi-file-pdf-box',
    color: '#b30b00',
  },
  xls: {
    icon: 'mdi-file-excel',
    color: '#207345',
  },
  msword: {
    icon: 'mdi-file-word',
    color: '#2b569a',
  },
  pptx: {
    icon: 'mdi-file-powerpoint',
    color: '#d24625',
  },
  image: {
    icon: 'mdi-file-image',
    color: '#753c8f',
  },
  video: {
    icon: 'mdi-file-video',
    color: '#f7a42f',
  },
  audio: {
    icon: 'mdi-file-music',
    color: '#bada55'
  },
  file: {
    icon: 'mdi-file',
    color: '#0e85cd',
  },
}
